module.exports = __webpack_public_path__ + "static/gallery_03-2994d8b00bf4ea213810c05422297d1d.jpg";